import { ApiUrl } from '@common/enums';
import { ApplianceModel } from '@common/models';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';
import { CommonProductQueryParams } from '@ee-api/queryParams';

const sinksApi = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchProgramSinks: builder.query<ApplianceModel[], CommonProductQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.SINKS,
                method: 'GET',
                params,
            }),
        }),
        fetchCustomerSuppliedSinks: builder.query<ApplianceModel[], CommonProductQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.CUSTOMER_SUPPLIED_SINKS,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const {
    useFetchCustomerSuppliedSinksQuery,
    useLazyFetchCustomerSuppliedSinksQuery,
    useLazyFetchProgramSinksQuery,
    useFetchProgramSinksQuery,
} = sinksApi;
